import { AUTH_KEY } from "./hooks/useAuthToken";
import { previewProjectSiteUrl } from "./utils/projectSiteUrl";

/**
 * Reads #cg_session=<jwt> from the URL, stores it as the CrabGear auth token,
 * then removes the fragment. Must run synchronously before the first React
 * render so hooks read the new token from localStorage.
 */
export function consumeSuperuserSessionHandoff() {
  if (typeof window === "undefined") {
    return;
  }
  const match = /^#cg_session=(.+)$/.exec(window.location.hash);
  if (!match) {
    return;
  }
  try {
    const token = decodeURIComponent(match[1]);
    if (!token) {
      return;
    }
    localStorage.setItem(AUTH_KEY, token);
    const url = `${window.location.pathname}${window.location.search}`;
    window.history.replaceState(null, document.title, url);
  } catch (e) {
    console.warn("Superuser session handoff failed:", e);
  }
}

/**
 * Navigate to another tenant on this deployment with a freshly minted JWT in
 * the URL hash (see consumeSuperuserSessionHandoff). The target host is built
 * from `window.location` and the project subdomain only — not the server
 * `url` field, so the same app works on e.g. gearrecoverynetwork.org and
 * crabgear.org. Preserves path and query on the target.
 */
export function navigateWithSessionHandoff(projectSubdomain, token) {
  if (typeof window === "undefined") {
    return;
  }
  const dest = new URL(previewProjectSiteUrl(projectSubdomain));
  dest.pathname = window.location.pathname;
  dest.search = window.location.search;
  dest.hash = `cg_session=${encodeURIComponent(token)}`;
  window.location.assign(dest.href);
}
